import { FC, useLayoutEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  IonTabs,
  IonFabButton,
  IonTabBar,
  IonTabButton,
  IonFab
} from '@ionic/react';
import { AllieTabsProps } from './Tabs.types';
import { AllieText } from '../Text';
import { AllieAddIcon } from '../../styling/icons';
import { AllieFabButton } from '../Fab/FabButton';
import './Tabs.css';

const selectedColor = '#61ADB7';

export const AllieTabs: FC<AllieTabsProps> = ({
  slot = 'bottom',
  tabs,
  selected,
  children,
  ...props
}) => {
  const originalFabRef = useRef<HTMLIonFabElement>(null);
  const fabRef = useRef<HTMLIonFabElement>(null);
  const [_, setSearchParamsFn] = useSearchParams();

  useLayoutEffect(() => {
    const timeoutId = setTimeout(() => {
      const originalFab = originalFabRef.current;
      const fab = fabRef.current;

      const originalFabRect = originalFab?.getBoundingClientRect();

      if (originalFab && fab && originalFabRect && originalFabRect.top !== 0) {
        const top = originalFabRect.top;
        fab.style.top = `${top}px`;
        fab.style.visibility = 'visible';
        fab.style.display = 'block';
      } else {
        if (fab) {
          fab.style.bottom = '7%';
          fab.style.visibility = 'visible';
          fab.style.display = 'block';
        }
      }
    }, 0);

    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <>
      <IonTabs {...props}>
        {children}
        <IonTabBar slot={slot} className="allie-tab-bar">
          {tabs.map((t, index) => (
            <IonTabButton
              tab={t.tab}
              href={t.href}
              className="allie-tab-button"
              key={`${index}-${t.tab}`}
              disabled={t.isFAB || t.disabled}
              onClick={() => {
                 setSearchParamsFn((prevSearchParams) => {
                   const newSearchParams = new URLSearchParams(prevSearchParams)
                   const currentKeys: string[] = [];
                   newSearchParams.forEach((_, k) => currentKeys.push(k));
                   currentKeys.forEach(key => {
                     newSearchParams.delete(key);
                   });
                   return newSearchParams;
                });   
              }}
            >
              {t.isFAB ? (
                <IonFab
                  ref={originalFabRef}
                  horizontal="center"
                  vertical="top"
                  edge
                  style={{ visibility: 'hidden' }}
                >
                  <IonFabButton>
                    <AllieAddIcon />
                  </IonFabButton>
                </IonFab>
              ) : (
                <>
                  <t.icon
                    color={selected === t.tab ? selectedColor : undefined}
                  />
                  <div style={{ marginTop: 5 }}>
                    <AllieText
                      type="button-small"
                      color={selected === t.tab ? 'primary-70' : 'neutral-90'}
                    >
                      {t.label}
                    </AllieText>
                  </div>
                </>
              )}
            </IonTabButton>
          ))}
        </IonTabBar>
      </IonTabs>
      <IonFab
        id="allie-fab-toolbar"
        ref={fabRef}
        horizontal="center"
        style={{ position: 'absolute', visibility: 'hidden' }}
      >
        <AllieFabButton>
          <AllieAddIcon />
        </AllieFabButton>
      </IonFab>
    </>
  );
};
